import {
  EKwikUIInputRadioChipOrientation,
  EKwikUIInputRadioChipSize
} from "./input-radio-chip.definitions";

export const DEFAULT_VALUES = {
  label: "",
  id: "radio-chip",
  formControlName: "form_control_radio_chip",
  placeholder: "",
  focus: false,
  invalid: false,
  disabled: false,
  size: EKwikUIInputRadioChipSize.M,
  orientation: EKwikUIInputRadioChipOrientation.HORIZONTAL,
  items: []
};

export const VALIDATE_KEY_VALUES = {
  label: true,
  id: true,
  formControlName: true,
  placeholder: true,
  focus: true,
  invalid: true,
  disabled: true,
  size: true,
  orientation: true,
  items: true
};
